import React from 'react';

type CreateIconProps = {
  width?: string;
  height?: string;
  color?: string;
  style?: React.CSSProperties;
};

function CreateIcon({
  width = '50',
  height = '50',
  color = '#6267AC',
}: CreateIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 26 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.37692 6.08789L11.122 10.6251C11.4058 11.363 11.5477 11.7319 11.7683 12.0422C11.9639 12.3172 12.2042 12.5575 12.4792 12.7531C12.7895 12.9737 13.1585 13.1156 13.8963 13.3994L18.4335 15.1445L13.8963 16.8896C13.1585 17.1734 12.7895 17.3153 12.4792 17.5359C12.2042 17.7315 11.9639 17.9718 11.7683 18.2468C11.5477 18.5571 11.4058 18.926 11.122 19.6639L9.37692 24.2011L7.63183 19.6639C7.34805 18.926 7.20615 18.5571 6.9855 18.2468C6.78994 17.9718 6.54964 17.7315 6.27461 17.5359C5.96429 17.3153 5.59537 17.1734 4.85753 16.8896L0.320312 15.1445L4.85753 13.3994C5.59537 13.1156 5.96429 12.9737 6.27461 12.7531C6.54964 12.5575 6.78994 12.3172 6.9855 12.0422C7.20615 11.7319 7.34805 11.363 7.63183 10.6251L9.37692 6.08789Z'
        fill='white'
      />
      <path
        d='M19.3396 0.201172L20.5612 3.37723C20.7598 3.89371 20.8592 4.15196 21.0136 4.36918C21.1505 4.5617 21.3187 4.72991 21.5112 4.8668C21.7285 5.02126 21.9867 5.12058 22.5032 5.31923L25.6792 6.54079L22.5032 7.76235C21.9867 7.961 21.7285 8.06033 21.5112 8.21479C21.3187 8.35168 21.1505 8.51989 21.0136 8.71241C20.8592 8.92963 20.7598 9.18787 20.5612 9.70436L19.3396 12.8804L18.1181 9.70436C17.9194 9.18787 17.8201 8.92963 17.6656 8.71241C17.5287 8.51989 17.3605 8.35168 17.168 8.21479C16.9508 8.06033 16.6925 7.961 16.1761 7.76235L13 6.54079L16.1761 5.31924C16.6925 5.12059 16.9508 5.02126 17.168 4.8668C17.3605 4.72991 17.5287 4.5617 17.6656 4.36918C17.8201 4.15196 17.9194 3.89371 18.1181 3.37723L19.3396 0.201172Z'
        fill='white'
      />
    </svg>
  );
}

export default CreateIcon;
